import { cssVariables } from "@/utils/utils";
import { Button, ConfigProvider } from "antd";
import { ButtonProps } from "antd/lib/button";
import { useBranding } from "../../../modules/branding/store";

export const SecondaryButton = ({ children, ...props }: ButtonProps) => {
  const branding = useBranding();

  return (
    <ConfigProvider theme={{ token: { colorPrimary: branding?.secondaryColor ?? cssVariables.colorGreen } }}>
      <Button type="primary" {...props}>
        {children}
      </Button>
    </ConfigProvider>
  );
};
